import { LoadingState, Skeleton } from '../common';

// The one loading placeholder every Account tab uses — People, Activity and
// Heatmap all render this while their data is in flight, so the three tabs can't
// drift into different loading looks. Built on the shared Skeleton/LoadingState
// primitives (a pulsing row list), no bespoke per-tab skeleton.
export function AccountTabSkeleton({ label, rows = 6 }: { label: string; rows?: number }) {
  return (
    <LoadingState label={label} className="account-tab-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="row" />
      ))}
    </LoadingState>
  );
}
